module.exports = __webpack_public_path__ + "img/CRDT-520.b258c765.png";